<template><div class="view">

	<fetching-content v-if="is_fetching_content" />
	<error-404 v-if="!artist && !is_fetching_content" />

	<main v-if="artist">
		<div class="artist-pretitle">{{maincat_title}}</div>
		<h1 class="artist-title">{{artist.full_name}}</h1>


		<div class="alinks">
			
			<router-link :to="'/artist/'+artist.slug" class="alink" @click.native.prevent="clickBook($event)" event="">Selected work</router-link>
			<router-link :to="'/artist/'+artist.slug+'/editorial'" class="alink" @click.native.prevent="clickBook($event)" event="">Editorial</router-link>
			<router-link :to="'/artist/'+artist.slug+'/advertising'" class="alink" @click.native.prevent="clickBook($event)" event="">Advertising</router-link>
			<router-link :to="'/artist/'+artist.slug+'/shows'" class="alink" @click.native.prevent="clickBook($event)" event="">Shows</router-link>
			<router-link :to="'/artist/'+artist.slug+'/biography'" class="alink" @click.native.prevent="clickBook($event)" event="" v-if="artist.bio_text">Biography</router-link>
			
			<a class="alink" v-if="artist.instagram_link" :href="artist.instagram_link" target="_blank">Instagram</a>
			<a class="alink" v-if="artist.modelsdotcom_link" :href="artist.modelsdotcom_link" target="_blank">Models.com</a>
		</div>

	</main>

	<main v-if="artist && book != 'biography'">

		<blocks ref="blocks" v-if="!editing_blocks" :blocks="book_blocks" :metadata="{artist,book}" />
		<block-editor v-if="editing_blocks" :blocks="book_blocks" :route_name="$route.name" :artist="artist" :book_slug="book" @updated="blocksUpdated()" @onexit="blockEditorOnExit()" />

		<p v-if="( !book_blocks || !book_blocks.length ) && !editing_blocks && loggedin_user" class="nothing-blocks">
			No content. You are seeing this only because you are logged in as admin.
		</p>

	</main>

	<main v-if="artist && book == 'biography'">
		<div>
			<div class="lbar">

				<div class="wysiwyg-content" v-html="artist.bio_text"></div>

			</div>
			<div class="mbar">

				<img class="blockimg" :src="mediaUrl(artist.bio_img_id,2500)" alt="">

			</div>				
		</div>
	</main>


	<main v-if="false && is_site_am && loggedin_user" class="am-admin-page-section">		

		<a :href="$store.state.base_url+'admin'" target="_blank" class="nicelink">Admin</a> &nbsp; 
		
		<template v-if="artist">
			<a :href="$store.state.base_url+'admin/artist/'+artist.id" target="_blank" class="nicelink">Edit artist</a> &nbsp; 
		</template>

		<template v-if="editable_layoutblocks">
			<span class="nicelink" @click="editLayout()">Edit layout</span> &nbsp; 
		</template>

	</main>


</div></template>
<script>
import helpers from '.././helpers.js'
import mixins from '.././mixins.js'
import Blocks from '.././components/Blocks'
import BlockEditor from '.././views/admin/AdminBlockEditor'
import ImgLazy from '.././components/ImgLazy'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		Blocks, 
		BlockEditor, 
		ImgLazy,
	},

	data(){ return {


	}},

	computed: {

		slug(){ return this.route.params.slug },

		book(){
			var book = this.route.params.book
			if( !book ) book = 'selectedwork'
			return book
		},

		artist(){ return this.$store.state.loaded_artist },

		book_blocks(){
			if( !this.book ) return
			if( !this.artist ) return			
			if( !this.artist.books ) return

			var book_slug = this.book
			if( this.book == 'full-book' ) book_slug = 'portfolio'

			if( !this.artist.books[book_slug] ) return
			
			var blocks = this.artist.books[book_slug]
			
			if( !this.editing_blocks ) {
			
				blocks = helpers.blocks_filter_capbelowblock(blocks)
				blocks = helpers.blocks_filter_nohideblocks(blocks)
				
				if( this.book == 'full-book' ) blocks = helpers.rearrange_blocks( '1-1', blocks )

			}
			
			return blocks
		},

		maincat_title(){
			var a = this.artist
			if(!a) return '&nbsp;'
			if( a.subtype_style == 1 ) return 'Stylist'
			if( a.subtype_artdirection == 1 ) return 'Art Direction'
			if( a.subtype_photography == 1 ) return 'Photography'
			if( a.subtype_setdesign == 1 ) return 'Set Design'
			if( a.subtype_hair == 1 ) return 'Hair'
			if( a.subtype_makeup == 1 ) return 'Makeup'
			return 'Artist'
		}

	},

	methods: {

		load_artist(){
			
			var _this = this

			this.$store.commit('set_loaded_artist', undefined )

			this.fetch( 'get_artist', { slug:this.slug }, 
			{ onSuccess: function(output){
				
				if( !output.data || !output.data.artist ) {
					console.log('valid request, but missing data')												
					return
				}

				_this.$store.commit('set_loaded_artist', output.data.artist )
				_this.setDocumentTitle( output.data.artist.full_name )
				window.prerenderReady = true

			}, onError: function(output){

				console.log('NAH - fetched but with error',output)		

			}})
				
		},

//---------------------------------------------------------------------------------------

		blocksUpdated(){
			//this.load_artist()
		},

//---------------------------------------------------------------------------------------

		blockEditorOnExit(){
			console.log('block editor exit')
			this.load_artist()
		},

//---------------------------------------------------------------------------------------

		clickBook(e)
		{

			//this.$router.push(e.target.getAttribute('href'))
			//return true

			if( this.book == 'biography' ) {
				this.$router.push(e.target.getAttribute('href'))
				return true
			}


			var _this = this
			var el = e.target		
			var link = el.getAttribute('href')      
			var $blockareas = document.querySelectorAll('.blocks .area')
			
			$blockareas.forEach(($el) => { $el.classList.add('fading-away-inactive') })

			setTimeout(()=>{
				_this.$router.push(link)				
			}, 450)

			setTimeout(()=>{			
				$blockareas.forEach(($el) => { $el.classList.remove('fading-away-inactive') })				
			}, 600)
			
		},

	},

	watch: {
		'$route' (to, from) {
			
			this.load_artist()

			//window.scrollTo( 0, 0 )


		}
	},
	
	mounted(){
		this.load_artist()
	},

	created(){
	},

}
</script>



// WEBPACK FOOTER //
// src/views/ArtistSingle.vue